import React from "react";
import Selector from "canvas-core-react/lib/Selector";

const CustomSelect = ({
  className,
  items = [],
  error,
  label = "",
  ...rest
}) => (
  <Selector
    className={className}
    error={error ? { label: "Error", messages: [error] } : undefined}
    label={label}
    {...rest}
  >
    {items.map(({ label, value }) => (
      <option key={value} value={value}>
        {label}
      </option>
    ))}
  </Selector>
);

export default CustomSelect;
